import { Link } from '@chakra-ui/react';

const StyledLink = (props) => {
  return (
    <Link
      color='blue.500'
      textDecoration='underline'
      target='_blank'
      rel='noopener noreferrer'
      {...props}
    />
  );
};

export default StyledLink;
